import { FC, CSSProperties } from 'react';
import { Box, Button, ButtonProps, makeStyles } from '@material-ui/core';

interface Props {
  cancel: ButtonProps;
  apply: ButtonProps;
  containerStyle?: CSSProperties;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      padding: '8px 16px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      borderTop: `1px solid ${theme.palette.grey[300]}`,
      [theme.breakpoints.down('xs')]: {
        padding: '6px 12px',
      },
    },
    button: {
      flex: 1,
    },
  }),
  { name: 'FilterButtons' },
);

export const FiltersButton: FC<Props> = ({ cancel, apply, containerStyle }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root} style={containerStyle}>
      <Button
        className={classes.button}
        size="small"
        variant="outlined"
        color="primary"
        {...cancel}
      >
        Cancel
      </Button>
      <Button
        className={classes.button}
        size="small"
        variant="contained"
        color="primary"
        {...apply}
      >
        Apply
      </Button>
    </Box>
  );
};
